import React from 'react';
import { EArchiveItem } from './EArchiveListItem';
// @ts-ignore
import styles from './EArchiveListItemGridView.module.scss';
import EArchiveListItemStatusBadge from './EArchiveListItemStatusBadge';
import EArchiveListItemVerificationBadge from './EArchiveListItemVerificationBadge';
import { useAppContext } from '../../../../../Services/AppContext';
import UserAvatarImage from '../../../../../Components/UserAvatar/UserAvatarImage';

interface Props {
	item: EArchiveItem;
	onClick: () => void;
}

const EArchiveListItemGridView: React.FC<Props> = ({ item, onClick }) => {
	const { isLatam } = useAppContext();
	return (
		<>
			<div className={styles.item} onClick={onClick}>
				<div className={styles.image}>
					<UserAvatarImage
						userId={item.user.id}
						profileImageUrl={item.user.profileImageUrl}
					/>
				</div>
				<div className={styles.name}>
					{item.user?.profile?.fullName ?? item.user?.email}
				</div>
				{!isLatam && (
					<div className={styles.birthNumber}>
						{item.user?.profile?.formattedBirthNumber}
					</div>
				)}
				<div className={styles.badges}>
					<div>
						<EArchiveListItemVerificationBadge
							csszResult={item.user.vzpResult}
							vzpResult={item.user.csszResult}
						/>
					</div>
					{item.user.workplaceMember?.dateOfDeath && (
						<img
							className={styles.cross}
							src='/dist/icons/cross-sharp-solid.svg'
							alt='cross'
						/>
					)}
				</div>
				<div className={styles.badgeWrapper}>
					<EArchiveListItemStatusBadge
						status={item.status}
						hasMeddi={item.user.hasMeddi}
					/>
				</div>
			</div>
		</>
	);
};

export default EArchiveListItemGridView;
